import React from 'react';
import { Form } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';

interface CardStatusFieldsProps {
  verified?: boolean | null;
  withoutSign?: boolean | null;
  propertyChange: (obj: { verified?: boolean; withoutSign?: boolean }) => void;
}

export const CardStatusFields: React.FC<CardStatusFieldsProps> = ({
  verified,
  withoutSign,
  propertyChange,
}) => {
  return (
    <>
      <FormRow controlId="verified" label="Zakończona edycja karty">
        <Form.Check
          type="checkbox"
          defaultChecked={verified ? true : false}
          onChange={e => propertyChange({ verified: e.target.checked })}
        />
      </FormRow>
      <FormRow
        controlId="withoutSign"
        label="Nie wymaga podpisu elektronicznego"
      >
        <Form.Check
          type="checkbox"
          defaultChecked={withoutSign ? true : false}
          onChange={e => propertyChange({ withoutSign: e.target.checked })}
        />
      </FormRow>
    </>
  );
};
